import { ReactNode, forwardRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {
  DialogContent,
  DialogContentProps,
  Theme,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      overflowY: 'auto',
      padding: theme.spacing(1, 3),
      maxHeight: 550,

      scrollbarWidth: 'thin',

      // Force show scrollbar if content is scrollable (mimic OSX style)
      ['&::-webkit-scrollbar']: {
        ['-webkit-appearance']: 'none',
        width: 7,
      },

      ['&::-webkit-scrollbar-thumb']: {
        borderRadius: 4,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        ['-webkit-box-shadow']: '0 0 1px rgba(255,255,255,.5)',
      },
    },
    dense: {
      padding: 0,
    },
    autoHeight: {
      maxHeight: 'none',
    },
  });

export type BodyProps = Omit<DialogContentProps, 'classes'> & {
  children: ReactNode;
  variant?: 'dense';
  autoHeight?: boolean;
} & WithStyles<typeof styles>;

export const Body = forwardRef<HTMLDivElement, BodyProps>((props, ref) => {
  const { className, classes, variant, autoHeight, ...rest } = props;

  return (
    <DialogContent
      {...rest}
      ref={ref}
      className={classNames(classes.root, className, {
        [classes.dense]: variant === 'dense',
        [classes.autoHeight]: autoHeight,
      })}
    />
  );
});

Body.displayName = 'DialogComposite.Body';

export default withStyles(styles)(Body);
